module.exports = __webpack_public_path__ + "img/o0-5.b424f2e5.jpg";